<template>
  <div :class="['on-the-hour', { houring: giftInfo.hourGiftFlag == 1 }]" v-if="giftInfo">
    <v-row type="flex" align="center" justify="space-between" tabindex="0" :aria-label="`整点加赠，${ariaformate}`">
      <div class="title">整点加赠</div>
      <div class="timer fs-30" aria-hidden="true">
        <span>{{ giftInfo.hourGiftFlag == 1 ? '距结束' : '距开始' }}</span>
        <v-count-down
          :start="giftInfo.hourGiftStartTime * 1"
          :current="giftInfo.giftNowTime * 1"
          :end="giftInfo.hourGiftEndTime * 1"
        ></v-count-down>
      </div>
    </v-row>
    <div class="sub-title fs-30">
      {{ giftInfo.shortDesc }}
    </div>
    <div :class="{ gray: giftInfo.hourGiftFlag != 1 }">
      <template v-for="(item, index) in timeGift">
        <giveaway-pop-item :giftItem="item" :positionKey="index"></giveaway-pop-item>
      </template>
    </div>
    <div :class="['more', 'border1px', { 'more-hide': !isShowMore }]" v-if="giftInfo.hourGiftPic">
      <div class="more-text" @click="isShowMore = !isShowMore">
        更多场次和赠品
        <img :class="{ rotate: isShowMore }" src="~assets/img/common/icon-down.png" alt="" />
      </div>
      <transition name="slide-fade">
        <div class="item-list border1px" v-show="isShowMore">
          <img v-lazy="giftInfo.hourGiftPic" alt="" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GiveawayPopItem from '../giveaway-pop-item'

export default {
  name: 'OnTheHour',
  props: {
    type: String,
    timeGift: {
      type: Array,
      default: () => []
    }
  },
  components: {
    GiveawayPopItem
  },
  computed: {
    ariaformate() {
      let time = this.giftInfo.hourGiftEndTime * 1 - this.giftInfo.giftNowTime * 1
      if (time > 0) {
        let h = parseInt(time / 3600000) % 24
        let m = parseInt(time / 60000) % 60
        return `${this.giftInfo.hourGiftFlag == 1 ? '距结束还有' : '距开始还有'}${h}小时${m}分钟`
      } else {
        return ''
      }
    }
  },
  watch: {
    // 整点
    timeGift: {
      handler(val) {
        this.giftInfo = val.length > 0 ? val[0] : ''
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      giftInfo: '',
      isShowMore: false
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss" src="./index.scss" />
